import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/desktop_agrupadas.png'
import _imports_1 from '@/assets/logo.png'
import _imports_2 from '@/assets/mobile_agrupadas_1.png'
import _imports_3 from '@/assets/ar.svg'
import _imports_4 from '@/assets/us.svg'
import _imports_5 from '@/assets/mobile_agrupadas_2.png'


const _hoisted_1 = { class: "flex flex-col lg:flex-row lg:items-center lg:gap-8" }
const _hoisted_2 = {
  id: "formulario",
  class: "py-12 clash-font"
}
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = { class: "flex flex-col items-center pb-2 text-white text-center" }
const _hoisted_5 = { class: "text-xl mt-2" }
const _hoisted_6 = { class: "text-xl" }
const _hoisted_7 = { class: "flex flex-col items-center w-full" }
const _hoisted_8 = { class: "flex items-center gap-4" }
const _hoisted_9 = { class: "container mx-auto px-4 py-6 pt-10 max-w-6xl items-center text-center" }
const _hoisted_10 = { class: "pi pi-user mr-2" }
const _hoisted_11 = { class: "container mx-auto px-4 py-6 max-w-6xl" }
const _hoisted_12 = { class: "text-3xl text-white w-full text-center pb-2 clash-font" }
const _hoisted_13 = { class: "text-2xl text-white w-full text-center pb-2 clash-font" }
const _hoisted_14 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 py-1" }
const _hoisted_15 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_16 = { class: "block mb-1" }
const _hoisted_17 = { class: "text-xl text-red-200" }
const _hoisted_18 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_19 = { class: "block mb-1" }
const _hoisted_20 = { class: "text-xl text-red-200" }
const _hoisted_21 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_22 = { class: "block mb-1" }
const _hoisted_23 = { class: "text-xl text-red-200" }
const _hoisted_24 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 py-1" }
const _hoisted_25 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_26 = { class: "block mb-1" }
const _hoisted_27 = { class: "text-xl text-red-200" }
const _hoisted_28 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_29 = { class: "block mb-1" }
const _hoisted_30 = { class: "text-xl text-red-200" }
const _hoisted_31 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 py-1" }
const _hoisted_32 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_33 = { class: "block mb-1" }
const _hoisted_34 = { class: "text-xl text-red-200" }
const _hoisted_35 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_36 = { class: "block mb-1" }
const _hoisted_37 = { class: "text-sm text-red-500" }
const _hoisted_38 = {
  key: 0,
  class: "w-full px-2 md:w-4/12"
}
const _hoisted_39 = { class: "block mb-1" }
const _hoisted_40 = { class: "text-xl text-red-200" }
const _hoisted_41 = {
  key: 1,
  class: "w-full px-2 md:w-4/12"
}
const _hoisted_42 = { class: "block mb-1" }
const _hoisted_43 = { class: "text-xl text-red-200" }
const _hoisted_44 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 py-1" }
const _hoisted_45 = { class: "block mb-1" }
const _hoisted_46 = { class: "text-xl text-red-200" }
const _hoisted_47 = {
  key: 0,
  class: "w-full px-2 md:w-6/12"
}
const _hoisted_48 = { class: "block mb-1" }
const _hoisted_49 = { class: "text-xl text-red-200" }
const _hoisted_50 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 py-1" }
const _hoisted_51 = { class: "block mb-1" }
const _hoisted_52 = { class: "text-xl text-red-200" }
const _hoisted_53 = {
  key: 0,
  class: "w-full px-2 md:w-6/12"
}
const _hoisted_54 = { class: "block mb-1" }
const _hoisted_55 = { class: "text-xl text-red-200" }
const _hoisted_56 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 py-1" }
const _hoisted_57 = { class: "block mb-1" }
const _hoisted_58 = { class: "text-xl text-red-200" }
const _hoisted_59 = {
  key: 0,
  class: "w-full px-2 md:w-6/12"
}
const _hoisted_60 = { class: "block mb-1" }
const _hoisted_61 = { class: "text-xl text-red-200" }
const _hoisted_62 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_63 = { class: "w-full px-2 space-x-2" }
const _hoisted_64 = {
  for: "declaro",
  class: "cursor-pointer"
}
const _hoisted_65 = { class: "flex flex-wrap py-2" }
const _hoisted_66 = ["disabled"]
const _hoisted_67 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_68 = { class: "pi pi-check mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Form = _resolveComponent("Form")!
  const _component_FullScreenLoader = _resolveComponent("FullScreenLoader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[24] || (_cache[24] = _createElementVNode("div", { class: "hidden lg:flex lg:w-6/12 justify-center items-center" }, [
        _createElementVNode("img", {
          src: _imports_0,
          class: "w-full object-contain"
        })
      ], -1)),
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "flex flex-col items-center" }, [
            _createElementVNode("img", {
              class: "pb-3 object-contain w-6/12 sm:w-5/12 lg:block lg:w-3/12",
              src: _imports_1
            })
          ], -1)),
          _createElementVNode("div", _hoisted_4, [
            _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-4xl md:text-4xl font-semibold" }, "Argentina Alimenta", -1)),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('label.fecha')), 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('label.lugar')), 1)
          ]),
          _cache[22] || (_cache[22] = _createElementVNode("img", {
            src: _imports_2,
            class: "lg:hidden mx-auto px-4 py-2 mb-3"
          }, null, -1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeLanguage('es'))),
                class: "hover:opacity-70 transition"
              }, _cache[19] || (_cache[19] = [
                _createElementVNode("img", {
                  src: _imports_3,
                  class: "h-6 rounded-full"
                }, null, -1)
              ])),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLanguage('en'))),
                class: "hover:opacity-70 transition"
              }, _cache[20] || (_cache[20] = [
                _createElementVNode("img", {
                  src: _imports_4,
                  class: "h-6 rounded-full"
                }, null, -1)
              ]))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_router_link, {
            to: "/prensa",
            class: "px-4 py-3 w-full clash-font rounded-lg border-2 bg-[#262E63] border-[#262E63] text-white hover:bg-[#212750] hover:text-[#29A5DE] hover:border-[#29A5DE] text-xl"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("i", _hoisted_10, null, 512), [
                [_vShow, !_ctx.isSubmitting]
              ]),
              _createTextVNode(_toDisplayString(_ctx.$t('label.soy.prensa')), 1)
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_Form, {
          onSubmit: _ctx.onSubmit,
          "validation-schema": _ctx.schema,
          class: "space-y-4 text-white",
          onInvalidSubmit: _ctx.onInvalidSubmit
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("h1", _hoisted_12, _toDisplayString(_ctx.$t('label.registro.visitante')), 1),
              _createElementVNode("h1", _hoisted_13, _toDisplayString(_ctx.$t('label.titulo.form')), 1),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_Field, {
                    name: "dni",
                    modelValue: _ctx.formData.dni,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.dni) = $event))
                  }, {
                    default: _withCtx(({ field, errors }) => [
                      _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('label.dni')), 1),
                      _createVNode(_component_InputText, _mergeProps(field, {
                        type: "text",
                        onBlur: _ctx.validarDni,
                        placeholder: _ctx.$t('label.dni'),
                        class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                      }), null, 16, ["onBlur", "placeholder", "class"]),
                      _createElementVNode("span", _hoisted_17, [
                        _createVNode(_component_ErrorMessage, { name: "dni" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_Field, {
                    name: "nombre",
                    modelValue: _ctx.formData.nombre,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.nombre) = $event))
                  }, {
                    default: _withCtx(({ field, errors }) => [
                      _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('label.nombre')), 1),
                      _createVNode(_component_InputText, _mergeProps(field, {
                        type: "text",
                        placeholder: _ctx.$t('label.nombre'),
                        class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                      }), null, 16, ["placeholder", "class"]),
                      _createElementVNode("span", _hoisted_20, [
                        _createVNode(_component_ErrorMessage, { name: "nombre" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_Field, {
                    name: "apellido",
                    modelValue: _ctx.formData.apellido,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.apellido) = $event))
                  }, {
                    default: _withCtx(({ field, errors }) => [
                      _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('label.apellido')), 1),
                      _createVNode(_component_InputText, _mergeProps(field, {
                        type: "text",
                        placeholder: _ctx.$t('label.apellido'),
                        class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                      }), null, 16, ["placeholder", "class"]),
                      _createElementVNode("span", _hoisted_23, [
                        _createVNode(_component_ErrorMessage, { name: "apellido" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t('label.razon.social')), 1),
                  _createVNode(_component_Field, {
                    name: "empresa",
                    modelValue: _ctx.formData.empresa,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.empresa) = $event))
                  }, {
                    default: _withCtx(({ field, errors }) => [
                      _createVNode(_component_InputText, _mergeProps(field, {
                        type: "text",
                        placeholder: _ctx.$t('label.razon.social'),
                        class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                      }), null, 16, ["placeholder", "class"]),
                      _createElementVNode("span", _hoisted_27, [
                        _createVNode(_component_ErrorMessage, { name: "empresa" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_Field, {
                    name: "cuit",
                    modelValue: _ctx.formData.cuit,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.cuit) = $event))
                  }, {
                    default: _withCtx(({ field, errors }) => [
                      _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t('label.cuit')), 1),
                      _createVNode(_component_InputText, _mergeProps(field, {
                        type: "text",
                        placeholder: _ctx.$t('label.cuit'),
                        class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                      }), null, 16, ["placeholder", "class"]),
                      _createElementVNode("span", _hoisted_30, [
                        _createVNode(_component_ErrorMessage, { name: "cuit" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t('label.mail')), 1),
                  _createVNode(_component_Field, {
                    name: "mail",
                    modelValue: _ctx.formData.mail,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.mail) = $event))
                  }, {
                    default: _withCtx(({ field, errors }) => [
                      _createVNode(_component_InputText, _mergeProps(field, {
                        type: "text",
                        placeholder: _ctx.$t('label.mail'),
                        class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                      }), null, 16, ["placeholder", "class"]),
                      _createElementVNode("span", _hoisted_34, [
                        _createVNode(_component_ErrorMessage, { name: "mail" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t('label.pais')), 1),
                  _createVNode(_component_Field, {
                    name: "pais",
                    modelValue: _ctx.formData.pais,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.pais) = $event))
                  }, {
                    default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                      _createVNode(_component_Select, {
                        filter: "",
                        onBlur: handleBlur,
                        "onUpdate:modelValue": handleChange,
                        "model-value": value,
                        class: _normalizeClass([{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}, "input-base"]),
                        placeholder: _ctx.$t('global.seleccione.opcion'),
                        options: _ctx.paises,
                        optionLabel: "descripcion"
                      }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "class", "placeholder", "options"]),
                      _createElementVNode("span", _hoisted_37, [
                        _createVNode(_component_ErrorMessage, { name: "pais" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                (_ctx.formData.pais?.id == '+54')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.$t('label.provincia')), 1),
                      _createVNode(_component_Field, {
                        name: "provincia",
                        modelValue: _ctx.formData.provincia,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.provincia) = $event))
                      }, {
                        default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                          _createVNode(_component_Select, {
                            onBlur: handleBlur,
                            "onUpdate:modelValue": handleChange,
                            "model-value": value,
                            placeholder: _ctx.$t('global.seleccione.opcion'),
                            options: _ctx.provincias,
                            optionLabel: "descripcion",
                            class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }])
                          }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "placeholder", "options", "class"]),
                          _createElementVNode("span", _hoisted_40, [
                            _createVNode(_component_ErrorMessage, { name: "provincia" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.formData.pais?.id != '+54')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.$t('label.provincia.estado')), 1),
                      _createVNode(_component_Field, {
                        name: "provinciaEstado",
                        modelValue: _ctx.formData.provinciaEstado,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.provinciaEstado) = $event))
                      }, {
                        default: _withCtx(({ field, errors }) => [
                          _createVNode(_component_InputText, _mergeProps(field, {
                            type: "text",
                            placeholder: "Ingrese su provincia o estado",
                            class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                          }), null, 16, ["class"]),
                          _createElementVNode("span", _hoisted_43, [
                            _createVNode(_component_ErrorMessage, { name: "provinciaEstado" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", {
                  class: _normalizeClass(["w-full px-2 md:w-12/12", { 'md:w-6/12': _ctx.formData.comoSeEntero?.id === 'Otro' }])
                }, [
                  _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.$t('label.como.se.entero')), 1),
                  _createVNode(_component_Field, {
                    name: "comoSeEntero",
                    modelValue: _ctx.formData.comoSeEntero,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.comoSeEntero) = $event))
                  }, {
                    default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                      _createVNode(_component_Select, {
                        onBlur: handleBlur,
                        "onUpdate:modelValue": handleChange,
                        "model-value": value,
                        class: _normalizeClass([{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}, "input-base"]),
                        placeholder: _ctx.$t('global.seleccione.opcion'),
                        options: _ctx.opcionesComoSeEntero,
                        optionLabel: "descripcion"
                      }, {
                        option: _withCtx(({ option }) => [
                          _createTextVNode(_toDisplayString(_ctx.$t(option.descripcion)), 1)
                        ]),
                        value: _withCtx(({ value }) => [
                          _createTextVNode(_toDisplayString(value ? _ctx.$t(value.descripcion) : _ctx.$t('global.seleccione.opcion')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onBlur", "onUpdate:modelValue", "model-value", "class", "placeholder", "options"]),
                      _createElementVNode("span", _hoisted_46, [
                        _createVNode(_component_ErrorMessage, { name: "comoSeEntero" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ], 2),
                (_ctx.formData.comoSeEntero?.id === 'Otro')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                      _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.$t('label.otro.como.entero')), 1),
                      _createVNode(_component_Field, {
                        name: "otroComoSeEntero",
                        modelValue: _ctx.formData.otroComoSeEntero,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.otroComoSeEntero) = $event))
                      }, {
                        default: _withCtx(({ field, errors }) => [
                          _createVNode(_component_InputText, _mergeProps(field, {
                            type: "text",
                            placeholder: _ctx.$t('label.otro.como.entero'),
                            class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                          }), null, 16, ["placeholder", "class"]),
                          _createElementVNode("span", _hoisted_49, [
                            _createVNode(_component_ErrorMessage, { name: "otroComoSeEntero" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", {
                  class: _normalizeClass(["w-full px-2 md:w-12/12", { 'md:w-6/12': _ctx.formData.cargo?.id === 'Otro' }])
                }, [
                  _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.$t('label.cargo')), 1),
                  _createVNode(_component_Field, {
                    name: "cargo",
                    modelValue: _ctx.formData.cargo,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.cargo) = $event))
                  }, {
                    default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                      _createVNode(_component_Select, {
                        onBlur: handleBlur,
                        "onUpdate:modelValue": handleChange,
                        "model-value": value,
                        class: _normalizeClass([{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}, "input-base"]),
                        placeholder: _ctx.$t('global.seleccione.opcion'),
                        options: _ctx.cargos,
                        optionLabel: "descripcion"
                      }, {
                        option: _withCtx(({ option }) => [
                          _createTextVNode(_toDisplayString(_ctx.$t(option.descripcion)), 1)
                        ]),
                        value: _withCtx(({ value }) => [
                          _createTextVNode(_toDisplayString(value ? _ctx.$t(value.descripcion) : _ctx.$t('global.seleccione.opcion')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onBlur", "onUpdate:modelValue", "model-value", "class", "placeholder", "options"]),
                      _createElementVNode("span", _hoisted_52, [
                        _createVNode(_component_ErrorMessage, { name: "cargo" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ], 2),
                (_ctx.formData.cargo?.id === 'Otro')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                      _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.$t('label.otro.cargo')), 1),
                      _createVNode(_component_Field, {
                        name: "otroCargo",
                        modelValue: _ctx.formData.otroCargo,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.otroCargo) = $event))
                      }, {
                        default: _withCtx(({ field, errors }) => [
                          _createVNode(_component_InputText, _mergeProps(field, {
                            type: "text",
                            placeholder: _ctx.$t('label.otro.cargo'),
                            class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                          }), null, 16, ["placeholder", "class"]),
                          _createElementVNode("span", _hoisted_55, [
                            _createVNode(_component_ErrorMessage, { name: "otroCargo" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", {
                  class: _normalizeClass(["w-full px-2 md:w-12/12", { 'md:w-6/12': _ctx.formData.rubro?.id === 'Otro' }])
                }, [
                  _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.$t('label.rubro')), 1),
                  _createVNode(_component_Field, {
                    name: "rubro",
                    modelValue: _ctx.formData.rubro,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.rubro) = $event))
                  }, {
                    default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                      _createVNode(_component_Select, {
                        onBlur: handleBlur,
                        "onUpdate:modelValue": handleChange,
                        "model-value": value,
                        class: _normalizeClass([{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}, "input-base"]),
                        placeholder: _ctx.$t('global.seleccione.opcion'),
                        options: _ctx.rubros,
                        optionLabel: "descripcion"
                      }, {
                        option: _withCtx(({ option }) => [
                          _createTextVNode(_toDisplayString(_ctx.$t(option.descripcion)), 1)
                        ]),
                        value: _withCtx(({ value }) => [
                          _createTextVNode(_toDisplayString(value ? _ctx.$t(value.descripcion) : _ctx.$t('global.seleccione.opcion')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onBlur", "onUpdate:modelValue", "model-value", "class", "placeholder", "options"]),
                      _createElementVNode("span", _hoisted_58, [
                        _createVNode(_component_ErrorMessage, { name: "rubro" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ], 2),
                (_ctx.formData.rubro?.id === 'Otro')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                      _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.$t('label.otro.rubro')), 1),
                      _createVNode(_component_Field, {
                        name: "otroRubro",
                        modelValue: _ctx.formData.otroRubro,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.otroRubro) = $event))
                      }, {
                        default: _withCtx(({ field, errors }) => [
                          _createVNode(_component_InputText, _mergeProps(field, {
                            type: "text",
                            placeholder: _ctx.$t('label.otro.rubro'),
                            class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                          }), null, 16, ["placeholder", "class"]),
                          _createElementVNode("span", _hoisted_61, [
                            _createVNode(_component_ErrorMessage, { name: "otroRubro" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                  _createVNode(_component_Field, {
                    name: "declaro",
                    modelValue: _ctx.formData.declaro,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.declaro) = $event))
                  }, {
                    default: _withCtx(({ handleChange, handleBlur, value }) => [
                      _createVNode(_component_Checkbox, {
                        checked: value,
                        "onUpdate:modelValue": handleChange,
                        onBlur: handleBlur,
                        size: "large",
                        inputId: "declaro",
                        binary: ""
                      }, null, 8, ["checked", "onUpdate:modelValue", "onBlur"]),
                      _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.$t('label.declaracion')), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "mt-8 px-4 py-3 w-full clash-font rounded-lg border-2 bg-[#262E63] border-[#262E63] text-white hover:bg-[#212750] hover:text-[#29A5DE] hover:border-[#29A5DE] text-3xl",
                  disabled: _ctx.isSubmitting
                }, [
                  _withDirectives(_createElementVNode("i", _hoisted_67, null, 512), [
                    [_vShow, _ctx.isSubmitting]
                  ]),
                  _withDirectives(_createElementVNode("i", _hoisted_68, null, 512), [
                    [_vShow, !_ctx.isSubmitting]
                  ]),
                  _createTextVNode(_toDisplayString(_ctx.$t('boton.registrarme')), 1)
                ], 8, _hoisted_66)
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema", "onInvalidSubmit"]),
        _cache[23] || (_cache[23] = _createElementVNode("img", {
          src: _imports_5,
          class: "lg:hidden mx-auto px-4 py-2 mb-3"
        }, null, -1))
      ])
    ]),
    _createVNode(_component_FullScreenLoader, { visible: _ctx.isSubmitting }, null, 8, ["visible"])
  ], 64))
}